/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';
import NextLink from 'next/link';

import styles from './Breadcrumb.module.scss';

import type { BreadcrumbProps } from './Breadcrumb.types';

export const Breadcrumb = ({ items, className }: BreadcrumbProps) => (
  <nav aria-label="Breadcrumb" className={cn(styles['breadcrumb'], className)}>
    <ol className={styles['list']}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <li key={`${item.label}-${index}`} className={styles['item']}>
            {item.href && !isLast ? (
              <NextLink href={item.href} className={styles['link']}>
                {item.label}
              </NextLink>
            ) : (
              <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
            )}
            {!isLast && (
              <span className={styles['sep']} aria-hidden="true">
                /
              </span>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
